import React from "react";

const PrimaryButton = props => {
  const { label, icon, additionalClassName, children, ...restProps } = props;
  return (
    <button
      className={`btn  btn-primary ${
        additionalClassName != null ? additionalClassName : ""
      }`}
      {...restProps}
    >
      {icon ? icon : null}
      {label || children}
    </button>
  );
};

export { PrimaryButton };



// WEBPACK FOOTER //
// ./src/modules/BookingPortal/components/Shared/PrimaryButton.js